module.exports = __webpack_public_path__ + "img/ic_activity_note.842cee60.svg";